module.exports = __webpack_public_path__ + "img/finances-bg-8v.ffa06978.png";